import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=c832664c"
import script from "./MessagesList.vue?vue&type=script&lang=ts"
export * from "./MessagesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports